import React, { useContext } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import GridIcon from '@icons/GridIcon';
import ListIcon from '@icons/ListIcon';
import LocationPinIcon from '@icons/LocationPinIcon';
import CalendarIcon from '@icons/CalendarIcon';
import ViewToggleButton from '../ViewToggleButton';

import { useViewTypeContext } from '@context/viewTypeContext';

const styles = {
    button: {
        outline: 'none',
    },
};

const listItemStyles = {
    listStyle: 'none',
};

const ViewToggleButtons = ({ displayMap = false, onViewTypeChange, showCalendar = false }) => {
    const [viewType, setViewType] = useViewTypeContext();
    const mobileViewToggleButton = classnames(
        'nav-item border-right-0 my-auto hidden-md-up',
        { list: viewType === 'list' },
        { cards: viewType === 'card' }
    );

    return (
        <>
            {/* Mobile List/Grid View Options */}
            <li className={mobileViewToggleButton} style={listItemStyles}>
                <button
                    type="button"
                    className="nav-link"
                    data-toggle="pill"
                    href="#"
                    role="tab"
                    style={styles.button}
                    onClick={() => {
                        const newViewType = viewType === 'list' ? 'card' : 'list';
                        setViewType(newViewType);
                        onViewTypeChange(newViewType);
                    }}
                >
                    <span style={{ visibility: 'hidden' }}>{viewType === 'list' ? 'List' : 'Card'}</span>
                </button>
            </li>

            {/* Desktop List/Grid View Options */}
            <li className="nav-item d-flex align-items-end hidden-sm-down gap-1">
                <div className="cards border-right-0 my-auto d-inline-block">
                    <ViewToggleButton
                        Icon={GridIcon}
                        active={viewType === 'card'}
                        onClick={() => {
                            if (viewType === 'card') return;
                            setViewType('card');
                            onViewTypeChange('card');
                        }}
                    />
                </div>

                <div className="list my-auto d-inline-block">
                    <ViewToggleButton
                        Icon={ListIcon}
                        active={viewType === 'list'}
                        onClick={() => {
                            if (viewType === 'list') return;
                            setViewType('list');
                            onViewTypeChange('list');
                        }}
                    />
                </div>

                {showCalendar && (
                    <div className="list my-auto d-inline-block">
                        <ViewToggleButton
                            Icon={CalendarIcon}
                            active={viewType === 'calendar'}
                            onClick={() => {
                                if (viewType === 'calendar') return;
                                setViewType('calendar');
                                onViewTypeChange('calendar');
                            }}
                        />
                    </div>
                )}

                {displayMap && (
                    <div className="my-auto d-inline-block">
                        <ViewToggleButton
                            Icon={LocationPinIcon}
                            active={viewType === 'map'}
                            onClick={() => {
                                if (viewType === 'map') return;
                                setViewType('map');
                                onViewTypeChange('map');
                            }}
                        />
                    </div>
                )}
            </li>
        </>
    );
};

ViewToggleButtons.propTypes = {
    displayMap: PropTypes.bool,
    onViewTypeChange: PropTypes.func.isRequired,
    showCalendar: PropTypes.bool,
};

export default ViewToggleButtons;
